 <template>
  <div>
    <v-app-bar
      flat
      color="transparent"
    >
      <v-toolbar-title>
        Best Books Menu Settings
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-row
        v-if="showSearch"
        align="center"
        style="max-width: 300px;"
      >
        <v-text-field
          flat
          hide-details
          single-line
          label="Search name, email or phone number"
          class="hidden-sm-and-down"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row>
      <v-btn
        class="ml-5"
        icon
        @click="showSearch = !showSearch"
      >
        <img
          src="@/assets/icons/search.svg"
          alt=""
        >
      </v-btn> -->
    </v-app-bar>
    <v-row>
      <v-col
        cols="12"
        md="5"
        sm="12"
        xs="12"
      >
        <us-states-selector
          v-model="form.us_states_id"
          :isMultiple="false"
          @change="fetcRecordList(1)"
        />
      </v-col>
    </v-row>
    <div
      class="pa-4"
      id="best-promo-list"
    >
    <!-- <span class="caption red--text">Only Published Bookies  will appear here.</span> -->
      <v-simple-table>
        <thead>
          <tr>
            <th></th>
            <th>Book</th>
            <th>State</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(list, i) in recordList"
            :key="i + '-' + list.id"
            class="hoverable"
            v-show="isPublished(list)"
          >
            <td>
              <v-img
                width="200"
                height="90"
                contain
                :src="list.bookmaker.logo.thumb_url"
                v-if="list.bookmaker"
              />
              <v-img
                v-else
                width="200"
                height="90"
                contain
                :src="require('@/assets/images/no-image.png')"
              >
              </v-img>
            </td>
            <td>
              {{  get(list.bookmaker, 'name', '') }}
            </td>
            <td>
              <div v-if="list.bookmaker">
                <span
                  v-for="(state, index) in list.bookmaker.states"
                  :key="index"
                >
                  {{state.name}}
                  <span v-if="list.bookmaker.states.length !== index +1">,</span>
                </span>
              </div>
            </td>
            <td>
              <!-- <template v-for="featuredIndex in orderIndex">
                <v-tooltip
                  left
                  :key="featuredIndex"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      color="grey lighten-2"
                    >mdi-star</v-icon>
                  </template>
                  <span> {{ featuredIndex }}</span>
                </v-tooltip>
              </template> -->
              <v-rating
                v-if="list.bookmaker"
                hover
                length="5"
                size="40"
                :value="list.order_index"
                color="yellow darken-2"
                @input="updateMenuIndex($event, list.bookmaker.id)"
              ></v-rating>
            </td>
          </tr>
          <tr v-if="loading">
            <td
              class="pl-0"
              v-for="n in 3"
              :key="n"
            >
              <v-skeleton-loader type="list-item" />
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <!-- <div
        v-if="listMeta.total"
        class="py-5 d-flex justify-center"
      >
        <small class="grey--text lighten-4">
          {{ listMeta.from }}-{{ listMeta.to }} of
          {{ listMeta.total | formatNumber }}
        </small>
      </div> -->
    </div>
    <div
      class="text-center mt-2 mb-8"
      v-if="listMeta.last_page > 1"
    >
      <v-pagination
        @input="pageChanged"
        :value="listMeta.current_page"
        :length="listMeta.last_page"
        :total-visible="10"
        circle
      ></v-pagination>
    </div>
    <v-overlay
      absolute
      :value="updating"
    >
      <v-dialog
        v-model="updating"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UsStatesSelector from '@/components/UsStatesSelector'
import Form from '@/utils/form'
import get from 'lodash/get'

const initialData = {
  us_states_id: 35

}

export default {
  name: 'BestBooksMenuSettingsPage',
  data () {
    return {
      loading: false,
      updating: false,
      loading_message: 'Fetching Data',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      form: new Form({
        ...initialData
      }),
      orderIndex: [1, 2, 3, 4, 5]

    }
  },

  components: {
    UsStatesSelector
  },

  computed: {
    ...mapState({
      recordList: state => state.bestBooksMenuSettings.list,
      listMeta: state => state.bestBooksMenuSettings.listMeta,
      requestStatus: state => state.bestBooksMenuSettings.requestStatus,
      requestMsg: state => state.bestBooksMenuSettings.requestMsg
    })
  },

  methods: {
    get,
    ...mapActions({
      getList: 'bestBooksMenuSettings/getList',
      updateOrderIndex: 'bestBooksMenuSettings/updateOrderIndex'
    }),

    async fetcRecordList (page = 1) {
      let params = { page }

      params.sort = '-created_at'
      this.updating = true
      this.loading_message = 'Fetching Data'
      params.us_states_id = this.form.us_states_id
      await this.getList(params)
      this.updating = false
    },

    showSnackbar (message, color) {
      this.snackbar.color = color
      this.snackbar.message = message
      this.snackbar.show = true
    },

    async updateMenuIndex ($evt, bookmakerId) {
      try {
        this.updating = true
        let data = {
          us_state_id: this.form.us_states_id,
          order_index: $evt,
          bookmakerId: bookmakerId
        }
        await this.updateOrderIndex(data)

        this.showSnackbar(this.requestMsg, this.requestStatus)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.', 'error')
          }
        } else {
          this.showSnackbar(error, 'error')
        }
      } finally {
        this.updating = false
        this.fetcRecordList()
      }
    },

    pageChanged (page) {
      this.fetcRecordList(page)
    },

    isPublished (list) {
      return list.bookmaker.publish_status === 'published'
    }
  },

  created () {
    this.fetcRecordList()
  },

  filters: {
    formatNumber (value) {
      return Number(value).toLocaleString()
    }
  }
}
</script>

<style scoped>
.hoverable:hover {
  cursor: pointer;
}
</style>
